// see: .gitignore

export const WORKER_SRC = '/pdfjs-dist/build/pdf.worker.min.mjs';

export const WORKER_FROM = './node_modules' + WORKER_SRC;
export const WORKER_TO = './public' + WORKER_SRC;
